import React, { useState } from 'react';
import cn from 'classnames';
import i18n from 'i18next';
import { useDispatch } from 'react-redux';
import { bool } from 'prop-types';

import { isMobile } from '~constants/sizes';
import CustomModal from '~app/components/CustomModal';
import LocalStorageService from '~services/LocalStorageService';
import ModalActions from '~redux/Modal/actions';
import { MODALS } from '~redux/Modal/constants';

import styles from './styles.module.scss';
import { MOBILE_CLOSE_MODAL_DELAY } from './constants';

const ForbiddenModal = ({ isOpen }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(isOpen);
  const [isOlder, setIsOlder] = useState(true);

  const handleConfirm = () => {
    LocalStorageService.setPlus18(true);
    setOpen(false);
  };

  const handleDeny = () => {
    setIsOlder(false);
  };

  const handleClose = () => {
    dispatch(ModalActions.closeModal(MODALS.FORBIDDEN));
  };

  return (
    <CustomModal
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClic={false}
      hideCloseButton
      isOpen={open}
      className={cn(styles.modal, {
        [styles.show]: open,
        [styles.hide]: !open
      })}
      overlayClassName={cn(styles.modalOverlay, {
        [styles.show]: open,
        [styles.hide]: !open
      })}
      closeTimeoutMS={isMobile() && MOBILE_CLOSE_MODAL_DELAY}
      onAfterClose={handleClose}>
      <div className={styles.content}>
        {isOlder ? (
          <>
            <div className={styles.title}>
              <span> {i18n.t('ForbiddenModal:welcome')} </span>
              <span> {i18n.t('ForbiddenModal:areOlder')} </span>
            </div>
            <span className={styles.subtitle}> {i18n.t('ForbiddenModal:subtitle')} </span>
            <div>
              <button
                type="button"
                className={cn('button primary center full-width', styles.btn)}
                onClick={handleConfirm}>
                {i18n.t('ForbiddenModal:positive')}
              </button>
              <button
                type="button"
                className={cn('button primary center full-width', styles.btn)}
                onClick={handleDeny}>
                {i18n.t('ForbiddenModal:negative')}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className={styles.title}>
              <span> {i18n.t('ForbiddenModal:sorry')} </span>
            </div>
            <span className={styles.subtitle}>{i18n.t('ForbiddenModal:noAgeEnough')}</span>
          </>
        )}
      </div>
    </CustomModal>
  );
};

ForbiddenModal.propTypes = {
  isOpen: bool
};

export default ForbiddenModal;
